import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator } from '@angular/material';
import { TransporterService } from 'src/app/services/transporter/transporter.service';
import { NotifierService } from 'angular-notifier';
import { RateService } from 'src/app/services/rate/rate.service';

@Component({
  selector: 'app-transportrate',
  templateUrl: './transportrate.component.html',
  styleUrls: ['./transportrate.component.scss']
})
export class TransportrateComponent implements OnInit {

  columnsToDisplay = [
    "transporter",
    'vehicleNumber',
    "rateType",
    "rate"
  ];


  from: string;
  transporter: string;
  rateData = new MatTableDataSource<any>();
  origin = [];
  transporters = [];
  loading: boolean = false;
  totalRecords: number = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private notifierService: NotifierService,
    private rateService: RateService
  ) {
  }

  ngOnInit() {
    this.getRates();
    this.rateData.data = [];
  }

  getRates() {
    this.rateData.data = [];
    this.loading = true;
    this.rateService.getRates().subscribe(rates => {
      this.loading = false;
      this.rateData.data = rates;
      this.totalRecords = rates.length;
      this.rateData.data.forEach(row => {
        row.isEditing = false;
      })

    
      this.rateData.data = rates;

      this.rateData.filterPredicate = (data: any, filter: string) => {
        let isTransporter = false, isVehiclenumber = false
        if (data) {
          if (data.transporter) {
            isTransporter = data.transporter.transporterName.toString().toLowerCase().indexOf(filter) != -1;
          }
          if (data.fleet) {
            isVehiclenumber = data.fleet.vehicleLicenseNumber.toString().toLowerCase().indexOf(filter) != -1;
          }
        }

        return isTransporter || isVehiclenumber;
      };
      this.rateData.paginator = this.paginator;
      console.log(this.rateData.data);
    }, Error => {
      this.loading = false;
      this.totalRecords = 0;
    })
  }

  applyFilter(filterValue: string) {
    this.rateData.filter = filterValue.trim().toLowerCase();
  }


  clicked(data,event){
    if(event.target.value<0)
      this.notifierService.notify("error",'Please Enter Valid Rate');
    else if (event.target.value && event.target.value!= data.rate) {
      data.rate = event.target.value;
      this.rateService.updateRates(data.fleet.fleetId, data.rate, data.rateType).subscribe(saved => {
         this.notifierService.notify("success",'Rate Saved Successfully');
      }, Error => {
        console.log(Error)
      })
  }
}

  addNewRate(rowIndex: number) {
    this.rateData.data[rowIndex].rate = 0;
    this.rateData.data[rowIndex].isEditing = true;
  }
}
